import { HttpClient } from '@/core/http/http-client';
import { ApiResponse } from '@/shared';

type SyncStatusJson = {
  lastSuccessfulSyncAt: string | null;
};

export class SyncStatusRepository {
  constructor(private readonly client: HttpClient) {}

  async getLastSuccessfulSyncAt(): Promise<Date | null> {
    const response = await this.client.get<ApiResponse<SyncStatusJson>>({
      url: 'status',
    });

    return response.data.lastSuccessfulSyncAt
      ? new Date(response.data.lastSuccessfulSyncAt)
      : null;
  }
}
